import { Play } from "lucide-react";
import Subtitle from "./Subtitle";
import Image from "next/image";
import Link from "next/link";

export default function SmallImagesNewsCard({
  title,
  subtitle,
  image,
  imagePosition = "right",
  imageAlt = "",
  // media_details,
  isVideo = false,
  subtitleProps = {},
  imageWidth = 118, // ✅ default width
  imageHeight = 78, // ✅ default height
  href,
  subtitleAs = "h3",
  fontWeight,

  loading = "lazy",
  fetchPriority = "low",
  decoding = "async",
}) {
  const CardWrapper = href ? Link : "div";

  return (
    <CardWrapper href={href} className={`block bg-white cursor-pointer `}>
      <div className="flex items-start gap-2 bg-background rounded-md ">
        {/* IMAGE LEFT */}
        {imagePosition === "left" && (
          <div
            className="relative shrink-0 rounded-lg overflow-hidden"
            style={{ width: imageWidth, height: imageHeight }}
          >
            <Image
              src={image}
              alt={imageAlt}
              fill
              loading={loading}
              fetchPriority={fetchPriority}
              sizes="(max-width:768px) 100vw, 236px"
              decoding={decoding}
              className="absolute inset-0 w-full h-full object-cover"
            />
            {isVideo && (
              <div className="absolute inset-0 flex items-center justify-center">
                <div
                  className="absolute top-1/2 left-1/2 
              -translate-x-1/2 -translate-y-1/2
              w-[60px] h-[60px] 
              bg-black/60 
              rounded-full 
              flex items-center justify-center
              cursor-pointer
      "
                >
                  <Play className="w-8 h-8 text-white fill-white stroke-none" />
                </div>
              </div>
            )}
          </div>
        )}

        {/* TEXT */}
        <div className="flex-1 min-w-0">
          <Subtitle
            {...subtitleProps}
            subtitleAs={subtitleAs}
            fontWeight={fontWeight}
          >
            {subtitle}
          </Subtitle>
        </div>

        {/* IMAGE RIGHT */}
        {imagePosition === "right" && (
          <div
            className="relative shrink-0 rounded-lg overflow-hidden"
            style={{ width: imageWidth, height: imageHeight }}
          >
            <Image
              src={image}
              alt={imageAlt}
              sizes="(max-width:768px) 100vw, 236px"
              fill
              loading={loading}
              fetchPriority={fetchPriority}
              decoding={decoding}
              className="absolute inset-0 w-full h-full object-cover"
            />
            {isVideo && (
              <div className="absolute inset-0 flex items-center justify-center">
                <div
                  className="absolute top-1/2 left-1/2 
        -translate-x-1/2 -translate-y-1/2
        w-[60px] h-[60px] 
        bg-black/60 
        rounded-full 
        flex items-center justify-center
        cursor-pointer
      "
                >
                  <Play className="w-8 h-8 text-white fill-white stroke-none" />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </CardWrapper>
  );
}

{
  /* <SmallImagesNewsCard
  mainTitle="Breaking News"
  showMainTitle
  title="Market me aaj girawat"
  showDot={false}
/>; */
}
